// src/pages/admin/ReceiptList.jsx
import React, { useEffect, useState } from 'react';
import {
  getInventoryReceipts,
  deleteInventoryReceipt,
} from "../../services/inventoryReceiptApi";
import AdminRoute from '../../routes/AdminRoute';
import { PageContainer, PageTitle, ActionButton, Button } from '../../ui';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAdminScope } from "../../context/AdminScopeContext";
import { useAdminConfirmation } from "./panel_engine/PanelServicesContext";

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td { border: 1px solid #ddd; padding: 8px; }
`;

export default function ReceiptList() {
  const [receipts, setReceipts] = useState([]);
  const navigate = useNavigate();
  const { selectedCompanyUuid } = useAdminScope();
  const confirm = useAdminConfirmation();

  const fetchReceipts = async () => {
    const { data } = await getInventoryReceipts({
      companyUuid: selectedCompanyUuid,
    });
    setReceipts(data);
  };

  useEffect(() => { fetchReceipts(); }, [selectedCompanyUuid]);

  return (
    <AdminRoute>
      <PageContainer>
        <PageTitle>Réception commande</PageTitle>
        <ActionButton onClick={() => navigate('/admin/inventory/receipts/new')}>
          Nouvelle réception
        </ActionButton>
        
        <Table>
          <thead>
            <tr>
              <th>Réf produit</th><th>Quantité</th><th>Coût HT</th><th>Coût TTC</th><th>Reçu le</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {receipts.map(r => (
              <tr key={r.uuid}>
                <td>{r.product_uuid}</td>
                <td>{r.quantity}</td>
                <td>{r.unit_cost_ht}</td>
                <td>{r.unit_cost_ttc}</td>
                <td>{new Date(r.received_at).toLocaleString()}</td>
                <td>
                  <Button onClick={() => navigate(`/admin/inventory/receipts/${r.uuid}`)}>✏️</Button>
                  <Button onClick={async () => {
                    const confirmed = await confirm({
                      title: "Supprimer la réception ?",
                      message: "Supprimer cette réception ?",
                      confirmLabel: "Supprimer",
                      cancelLabel: "Conserver",
                      intent: "danger",
                    });

                    if (!confirmed) return;

                    await deleteInventoryReceipt(r.uuid, {
                      companyUuid: selectedCompanyUuid,
                    });
                    await fetchReceipts();
                  }}>🗑️</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </PageContainer>
    </AdminRoute>
  );
}
